// extracted by css-extract-rspack-plugin
export default {"time":"time-c02VNB"};